import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'

const propTypes = {
  showOnCheckout: PropTypes.bool
}

/**
 * To give nice look on `Vouhcer.show_on_checkout`.
 * It maps `showOnCheckout` to certain style and pass to `StatusBadge`.
 * @param {boolean} showOnCheckout Voucher show on checkout value.
 */
const VoucherShowOnCheckoutBadge = ({ showOnCheckout }) => {

  const color = showOnCheckout ? 'primary' : 'info'
  const label = showOnCheckout ? 'Yes' : 'No'

  return <StatusBadge color={ color } label={ label } />
}

VoucherShowOnCheckoutBadge.propTypes = propTypes

export default VoucherShowOnCheckoutBadge
